import React from "react";
import SyntaxHighlighter from "react-syntax-highlighter";

const NLTP = ({ inputText, isGenerating, text, presetSelected }) => {
  return (
    <>
      <p class="preset-title">Natural Language To Python</p>

      {inputText ? (
        <>
          <p class="text-muted syntax-high">
            <SyntaxHighlighter
              language="python"
              // style={darcula}
              autodetect={true}
              dark={true}
              // style={{ backgroundColor: "#011c34" }}
            >
              {inputText}
            </SyntaxHighlighter>
          </p>

          {isGenerating == true ? (
            <p
              class="text- mb-0 mt-2"
              style={{
                fontSize: "14px",
                color: "black",
              }}
            >
              Processing...
            </p>
          ) : (
            <>
              {text && (
                <p
                  style={{
                    color: "black",
                  }}
                  class="text- mb-0 text-"
                >
                  <SyntaxHighlighter
                    language="python"
                    // style={darcula}
                    autodetect={true}
                    dark={true}
                  >
                    {text}
                  </SyntaxHighlighter>
                </p>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <SyntaxHighlighter
            language="python"
            // style={darcula}
            autodetect={true}
            dark={true}
          >
            {presetSelected?.label}
          </SyntaxHighlighter>
        </>
      )}
    </>
  );
};

export default NLTP;
